import { render, staticRenderFns } from "./StepsToActivateNumber.vue?vue&type=template&id=5779c36e&"
import script from "./StepsToActivateNumber.vue?vue&type=script&lang=js&"
export * from "./StepsToActivateNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports